module.exports = __webpack_public_path__ + "img/homenew.dc39b100.png";